import { LEGAL_OPERATOR } from "./legalMeta";

export const LANDING_COMPARISON = {
  title: "InChat и классическая LMS",
  subtitle:
    "Сравнение без привязки к конкретному вендору — типичный сценарий «курсы в браузере» против обучения в мессенджере.",
  columns: [
    { id: "inchat", label: "InChat", highlight: true },
    { id: "lms", label: "LMS в браузере" },
  ],
  rows: [
    {
      label: "Где проходит обучение",
      values: ["Telegram и MAX — там, где команда уже общается", "Отдельный сайт или приложение"],
    },
    {
      label: "Запуск для сотрудника",
      values: ["Ссылка в чат — без регистрации и паролей", "Логин, пароль, часто отдельный онбординг"],
    },
    {
      label: "Формат",
      values: ["Интерактивные сценарии, база знаний, тренажёр", "Чаще линейные курсы и видео"],
    },
    {
      label: "Подсказки на смене",
      values: ["База знаний в боте — ответ за секунду", "Поиск по курсам или PDF в другой системе"],
    },
    {
      label: "Настройка HR",
      values: ["Редактор без программистов, публикация за минуты", "Часто нужны методисты и интеграторы"],
    },
    {
      label: "Модель оплаты",
      values: ["Фикс в месяц по числу сотрудников", "Часто per-seat + внедрение и лицензии"],
    },
  ],
};

export const LANDING_SOCIAL_PROOF = {
  title: "Цифры, которые видит HR после запуска",
  subtitle:
    "Пример дашборда аналитики — так выглядят метрики, когда команда проходит программу в боте.",
  note: "Данные на главной — демонстрационные, для иллюстрации возможностей платформы.",
  metrics: [
    { value: "847", label: "Запусков программы" },
    { value: "72%", label: "Доля завершивших" },
    { value: "523", label: "Уникальных сотрудников" },
  ],
  industries: [
    "HoReCa и ритейл",
    "Продажи B2B",
    "Служба поддержки",
    "Склад и производство",
  ],
};

export const LANDING_FAQ_EXTRA = [
  {
    question: "Подходит ли InChat для корпоративного обучения?",
    answer:
      "Да. Вы создаёте сценарий обучения, загружаете видео-материалы и делитесь ссылкой с сотрудниками. Формат подходит для адаптации, продуктовых тренингов, регламентов и любых программ, где важна вовлечённость.",
  },
  {
    question: "Чем интерактивный сценарий лучше обычного видео-курса?",
    answer:
      "Сотрудник не просто смотрит запись — он принимает решения и проходит свой путь. Сценарий позволяет адаптировать материал под разные роли, уровни подготовки или ситуации. Это повышает вовлечённость и лучше закрепляет материал.",
  },
  {
    question: "Куда обращаться при вопросах по запуску?",
    answer:
      "По любым вопросам вы можете написать в поддержку в Telegram. Специалисты отвечают с 9 до 20 часов по московскому времени.",
    supportLink: true,
  },
];

export const SUPPORT_TELEGRAM = LEGAL_OPERATOR.telegram.replace("@", "");
export const SUPPORT_TELEGRAM_LINK = LEGAL_OPERATOR.telegramUrl;
export const SUPPORT_EMAIL = LEGAL_OPERATOR.email;
